import { domainCode } from '../../../../constants/staticPageConstants';

export interface CommonData {
  name: string;
  link: string;
}
export interface ContactData {
  [key: number]: string;
}

export interface AboutUsData {
  [key: number]: CommonData[];
}
export interface SolutionData {
  [key: number]: CommonData[];
}
const commonData_Aboutus = {
  name: 'Company',
  link: 'https://www.clear.in/s/about-us?utm_ref=clear_homepage_pages_navbar',
};

export const ABOUT_US: AboutUsData = {
  [domainCode.cleartaxFR]: [commonData_Aboutus],
  [domainCode.cleartaxES]: [commonData_Aboutus],
  [domainCode.cleartaxPL]: [commonData_Aboutus],
  [domainCode.cleartaxMY]: [
    {
      name: 'Company',
      link: 'https://www.cleartax.com/my/en/about-us',
    },
  ],
};

export const commonData_SOLUTIONS = [
  {
    name: 'E-invoicing Software',
    link: 'https://www.cleartax.com/fr/en#einv-cards',
  },
  {
    name: 'Accounts Payable Automation',
    link: 'https://www.cleartax.com/fr/en#erp-fold',
  },
  {
    name: 'Accounts Receivable Automation',
    link: 'https://www.cleartax.com/fr/en#erp-fold',
  },
  {
    name: 'Supply Chain Financing',
    link: 'https://www.cleartax.com/fr/en#erp-fold',
  },
  {
    name: 'Clear Finance Cloud',
    link: 'https://www.clear.in/clear-finance-cloud?utm_ref=clear_homepage_pages_navbar',
  },
];

export const SOLUTIONS: SolutionData = {
  [domainCode.cleartaxFR]: commonData_SOLUTIONS,
  [domainCode.cleartaxES]: commonData_SOLUTIONS,
  [domainCode.cleartaxPL]: commonData_SOLUTIONS,
};

const commonData_Contact_US =
  'https://www.clear.in/s/contact-us?utm_ref=clear_homepage_pages_navbar';

export const CONTACT_US_PAGE: ContactData = {
  [domainCode.cleartaxFR]: commonData_Contact_US,
  [domainCode.cleartaxES]: commonData_Contact_US,
  [domainCode.cleartaxPL]: commonData_Contact_US,
  [domainCode.cleartaxMY]: 'https://www.cleartax.com/my/contact-us',
};
